import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {ShipmentDirectionsActions} from '../store';
import {ShipmentDirectionsSelectors} from '../store/selectors';

@Injectable()
export class ShipmentDirectionsLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadShipmentDirectionsDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadShipmentDirectionsDone() {

    return this.store.pipe(
      select(ShipmentDirectionsSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(ShipmentDirectionsActions.ReadShipmentDirections());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
